import { useFeatureFlagAssignedFromString } from '@shared/core/featureFlags';

export const useSlapAdsRegistryExperiment = (eventId?: string) => {
  const slapAdRegistryExperimentEnabled = useFeatureFlagAssignedFromString('websiteGuestRegistryAd', eventId ?? '', 50);

  return slapAdRegistryExperimentEnabled;
};
